export const features = [
  {
    category: 'Creating',
    visible: false,
    options: [
      {
        name: 'Drag & drop builder for elearning authoring',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Layout and theme customization',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Issue digital badges',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: '# of mini-courses',
        basic: '3',
        pro: 'Unlimited',
        elite: 'Unlimited',
      },
      {
        name: 'Landing pages for group of mini-courses',
        basic: '1',
        pro: 'Unlimited',
        elite: 'Unlimited',
      },
      {
        name: 'AI Course Creator',
        basic: 'Limited',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Converting a resource into a mini-course',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'In-page AI-Assistant',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: '# of AI credits per month',
        basic: '-',
        pro: '1000',
        elite: '3000',
      },
    ],
  },
  {
    category: 'Delivering',
    visible: false,
    options: [
      {
        name: 'Learner engagements & views',
        basic: 'Unlimited',
        pro: 'Unlimited',
        elite: 'Unlimited',
      },
      { name: 'Sharing with links', basic: 'true', pro: 'true', elite: 'true' },
      {
        name: 'Embedding on webpages',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Custom domains (CNAME)',
        basic: '-',
        pro: '5',
        elite: 'Unlimited',
      },
      { name: 'Export to PDF', basic: '-', pro: 'true', elite: 'true' },
      {
        name: 'Removal of Mini Course Generator Badge',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      { name: 'Export to SCORM', basic: '-', pro: '-', elite: 'true' },
    ],
  },
  {
    category: 'Granting Access',
    visible: false,
    options: [
      {
        name: 'Grant access to everyone (no login)',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Grant access after password wall',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Grant access after email verification',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Grant access after payment',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Grant access only with invitation',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Grant access through in-app authentication',
        basic: '-',
        pro: '-',
        elite: 'Up to 250 active learners\nper month',
      },
      {
        name: 'Grant access through Intercom',
        basic: '-',
        pro: '-',
        elite: 'Up to 2.500 active learners\nper month',
      },
    ],
  },
  {
    category: 'Managing & Integrations',
    visible: true,
    options: [
      {
        name: 'User limit of analytics per mini-course',
        basic: '25',
        pro: 'Unlimited',
        elite: 'Unlimited',
      },
      {
        name: 'SEO settings for each mini-course',
        basic: 'true',
        pro: 'true',
        elite: 'true',
      },
      { name: 'Certification', basic: '-', pro: 'true', elite: 'true' },
      {
        name: 'Adding .js codes to head & body',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Automations with Zapier & Make integrations',
        basic: '-',
        pro: 'true',
        elite: 'true',
      },
      {
        name: 'Dedicated account manager',
        basic: '-',
        pro: '-',
        elite: 'true',
      },
    ],
  },
]
